"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MovingGradient = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const moving = (0, styled_components_1.keyframes) `
  from {
    left: -100%
  }

  to {
    left: 100%
  }
`;
exports.MovingGradient = styled_components_1.default.div `
  overflow: hidden;
  position: relative;
  background: ${monera_app_core_1.Gray_1100};
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height};
  ::before {
    position: absolute;
    content: '';
    top: 0;
    background: linear-gradient(90deg, ${monera_app_core_1.Gray_1100}, ${monera_app_core_1.Gray_700}, ${monera_app_core_1.Gray_1100});
    height: 100%;
    width: 100%;
    left: 100%;
    animation ${moving} 1s cubic-bezier(0.4, 0, 0.2, 1) infinite 0s, 0.5s;
  }
`;
